import { AutoCompleteLabel } from 'types';

export enum LabelsFormFieldsNames {
  Labels = 'labels',
}

export interface LabelsFormFields {
  [LabelsFormFieldsNames.Labels]?: AutoCompleteLabel[];
}
